import Panel from '@/features/report/shared/Panel/Panel';
import styles from './EditableConclusionsSection.module.css';

interface EditableConclusionsSectionProps {
  title?: string;
}

/**
 * The Conclusions section has no configurable structure — the reader
 * renders a free-form rich text editor. This placeholder shows the
 * builder where the section will appear in the final worksheet.
 */
export function EditableConclusionsSection({
  title = 'Conclusions',
}: EditableConclusionsSectionProps) {
  return (
    <Panel title={title}>
      <div className={styles.placeholder}>
        Free-form conclusions text area (rendered on the reader).
      </div>
    </Panel>
  );
}
